import { generate, ToVariants } from '@/components/experiments/Core/generateBasicExperimentComponent';

// ?preferred_variant=POPULAR-PROVIDER-PAGE-EXP_4:control
// ?preferred_variant=POPULAR-PROVIDER-PAGE-EXP_4:variant_1
// ?preferred_variant=POPULAR-PROVIDER-PAGE-EXP_4:variant_2
// ?preferred_variant=POPULAR-PROVIDER-PAGE-EXP_4:variant_3
// ?preferred_variant=POPULAR-PROVIDER-PAGE-EXP_4:variant_4

export const PopularProviderPageExpName = 'POPULAR-PROVIDER-PAGE-EXP_4';
export const PopularProviderPageExpVariants = {
	CONTROL: 'control',
	VARIANT_1: 'variant_1',
	VARIANT_2: 'variant_2',
	VARIANT_3: 'variant_3',
	VARIANT_4: 'variant_4',
} as const;

export type PopularProviderPageExpVariants = ToVariants<typeof PopularProviderPageExpVariants>;
const providersAcceptedParams = new Set([
	'disney-plus',
	'netflix',
	'amazon-prime-video',
	'hulu',
	'paramount-plus',
	'apple-tv-plus',
	'peacock-premium',
	'youtube',
	'fubotv',
	'crunchyroll',
	'kocowa',
	'mgm-plus',
	'starz',
	'showtime',
	'amc+',
	'funimation-now',
	'max',
	'popcornflix',
	'tubi-tv',
	'freevee',
	'crackle',
]);
export default generate(
	PopularProviderPageExpName,
	PopularProviderPageExpVariants,
	() => {
		return true;
	},
	(instance: any) => {
		return providersAcceptedParams.has(instance?.activeRoute?.params?.provider);
	}
);
